// extracted by mini-css-extract-plugin
module.exports = {"qrgen":"QrGenerator_qrgen__cfhqt","temp":"QrGenerator_temp__3k8Az","bold":"QrGenerator_bold__1gnXE","hidden":"QrGenerator_hidden__2z9zm"};